
import {footerBGC, footerAcolor, footerQBcolor} from '../../utils/Utils'

const Footer = ({contentLng}) => { 

return(

<div className='Footer' style={footerStyle}>
<p>{contentLng.devText} <a href="https://qbmedia.co.il" target="_blank" rel="noreferrer" style={footerStyle.a}>{contentLng.company}</a></p>
</div>

)
}

const footerStyle = {
    marginBottom:"56px",
    backgroundColor:footerBGC,
    height:"100px",
    color:footerAcolor,
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    a:{
        fontWeight:"bold",
        textDecoration:"none",
        color:footerQBcolor,
        pointer:"cursor"
    }
}

export default Footer